// extracted by mini-css-extract-plugin
export var aboveInput = "_ni-0";
export var actionButton = "_ni-5";
export var actionButtonContainer = "_ni-1";
export var actionIcon = "_ni-6";
export var aiInfoContainer = "_ni-2";
export var attachmentWrapper = "_ni-7";
export var bold = "_ni-3";
export var checkIcon = "_ni-8";
export var clickingRecipientBar = "_ni-11";
export var commentThreadSwitch = "_ni-a";
export var draftImage = "_ni-b";
export var draftImageContainer = "_ni-c";
export var draftImages = "_ni-e";
export var editButton = "_ni-g";
export var editor = "_ni-f";
export var editorContainer = "_ni-y";
export var editorErrorTooltipWrapper = "_ni-9";
export var headerDivider = "_ni-h";
export var icon = "_ni-i";
export var info = "_ni-j";
export var internal = "_ni-n";
export var internalDivider = "_ni-k";
export var internalMessage = "_ni-l";
export var messageInputCard = "_ni-m";
export var messageInputForm = "_ni-o";
export var messageInputFormInternal = "_ni-p";
export var options = "_ni-q";
export var publicMessageCustomer = "_ni-s";
export var publicMessageMerchant = "_ni-r";
export var removeImageButton = "_ni-d";
export var replyButtons = "_ni-t";
export var showSignatureButton = "_ni-u";
export var spinner = "_ni-v";
export var verticalButtonDivider = "_ni-4";
export var visibilitySelector = "_ni-w";
export var warning = "_ni-x";
export var wrappingText = "_ni-z";
export var writingInternalNoteTopBorder = "_ni-10";